/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 4 hook(s) need dependency review; fix each and remove this directive */
import { useTranslation, untranslated } from "@i18n";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IconComponent from "@CubeComponents/icons";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Accordion from "@CubeComponents/html/accordion/materialUiAccordian/index";
import SelectDropDown from "@CubeComponents/Mui_Form/SelectDropDown";
import { formController, formFlowController } from "@Actions/Forms";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import UserNameTagComponent from "@CubeComponents/html/UserNameTagComponent";
import InPlaceEditorComponent from "@CubeComponents/Mui_Form/InPlaceEditorComponent";
import _ from "lodash";
import { showToastNotification } from "@Reducers/toastSlice";
import { SOMETHING_WENT_WRONG, TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from "@Services/constants";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import { PlusIcon } from "@Components/StickySidebarViewer/assets/selectionIcons";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import AddUser from "./addUserModal";
import FormPreview from "@Features/portal-settings/components/PortalSetings/Configuration/FormsAndFields/FormTemplate/formPreview";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";
import { Box, Chip } from "@mui/material";
import Text from "@CubeComponents/html/Text/Text";
import { getSectionName } from "./constants";
import { RootState } from "@Reducers/index";
import CheckBoxComponent from "@CubeComponents/Mui_Form/CheckBox";

interface AddUserQuery {
  spaceId: string;
  selectionScope: string;
  params: {
    spaceId: string;
    selectionScope: string;
  };
}

interface FormFlowDetails {
  name?: string;
  selectedForm?: { _id?: string };
  space?: { _id?: string };
}

function FormFlowCreationNew({
  formFlowId = null,
  projectId,
  handleBackClick = () => {},
  previewMode = false,
  selectedTemplate = {},
  source = "",
  handleCancelFormAttachment = () => {},
  handleCreateClick = () => {},
  showLoader = false,
  spaceId,
  singleLevelEditMode = false,
  formFlow = null,
  editLevelIndex = null,
  onLevelChange = () => {},
}: any) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [formFlowLevels, setFormFlowLevels] = useState<any>(() =>
    singleLevelEditMode && Array.isArray(formFlow)
      ? formFlow.map((level: any) => ({
          ...level,
          headingEditMode: false,
          subBtnEditMode: false,
          rejectBtnEditMode: false,
          approveBtnEditMode: false,
          rollBackBtnEditMode: false,
        }))
      : [],
  );
  const [formFlowData, setFormFlowData] = useState<FormFlowDetails>({});
  const [updatedTemplate, setUpdatedTemplate] = useState<any>(selectedTemplate);
  const [editMode, setEditMode] = useState(!!singleLevelEditMode);
  const [modalState, setModalState] = useState<any>({
    modalName: "",
    levelIndex: null,
    stepIndex: null,
    currentUsers: [],
    currentSections: [],
  });
  const spaceUsers = useSelector((state: RootState) => state.spaceUsers);
  const [allSectionsUsedForFill, setAllSectionsUsedForFill] = useState<any>([]);
  const [allSelectedSections, setAllSelectedSections] = useState<any>([]);
  const [allSectionsUsedForVerify, setAllSectionsUsedForVerify] = useState<any>([]);
  const [saveBtnState, setSaveBtnState] = useState(false);
  const [openNewFlowSaveModal, setOpenNewFlowSaveModal] = useState({ status: false, title: "" });
  const [addUserQuery, setAddUserQuery] = useState<AddUserQuery | null>(null);
  const resolvedSpaceId = spaceId || formFlowData?.space?._id;
  useEffect(() => {
    if (resolvedSpaceId) {
      setAddUserQuery({
        spaceId: resolvedSpaceId,
        selectionScope: "space",
        params: {
          spaceId: resolvedSpaceId,
          selectionScope: "space",
        },
      });
    }
  }, [resolvedSpaceId]);

  const actionSteps = [
    {
      name: t("Move Forward"),
      id: "moveForward",
      btnTxtField: "submitBtnTxt",
      btnTxtEditMode: "subBtnEditMode",
      usersField: "allowedUsersToSubmit",
    },
    {
      name: t("Move Backward"),
      id: "moveBackward",
      btnTxtField: "rollBackBtnTxt",
      btnTxtEditMode: "rollBackBtnEditMode",
      usersField: "allowedUsersToRollBack",
    },
    {
      name: t("Reject Form"),
      id: "rejectForm",
      btnTxtField: "rejectBtnTxt",
      btnTxtEditMode: "rejectBtnEditMode",
      usersField: "allowedUsersToReject",
    },
    {
      name: t("Approve Form"),
      id: "approveForm",
      btnTxtField: "approveBtnTxt",
      btnTxtEditMode: "approveBtnEditMode",
      usersField: "allowedUsersToApprove",
    },
  ];
  const initialValue = [
    {
      heading: "Pre-Submission",
      headingEditMode: false,
      dataSource: [],
      submitBtnTxt: "Submit",
      rejectBtnTxt: "Reject",
      subBtnEditMode: false,
      rejectBtnEditMode: false,
      actionStatus: false,
      actionDetails: {},
      allowedUsersToSubmit: [],
      allowedUsersToReject: [],
    },
    {
      heading: "Post-submission",
      headingEditMode: false,
      dataSource: [],
      approveBtnTxt: "Approve",
      rejectBtnTxt: "Reject",
      rollBackBtnTxt: "Revert Back",
      approveBtnEditMode: false,
      allowDynamicUserConfig: false,
      rejectBtnEditMode: false,
      rollBackBtnEditMode: false,
      actionStatus: false,
      actionDetails: {},
      allowedUsersToApprove: [],
      allowedUsersToReject: [],
      allowedUsersToRollBack: [],
    },
  ];

  const closeAddModal = () => {
    setModalState({
      modalName: "",
      levelIndex: null,
      stepIndex: null,
      currentUsers: [],
      currentSections: [],
    });
  };
  const handleAddUsersClick = ({ allSelectedUsers }: any) => {
    const allUsers: any = allSelectedUsers.map((user: { id: string; fullName: string }) => ({
      id: user.id,
      name: user.fullName,
    }));
    const modifiedData: any = _.cloneDeep(formFlowLevels);
    if (modalState.actionStep) {
      modifiedData[modalState.levelIndex][modalState.actionStep.usersField] = allUsers;
    } else {
      modifiedData[modalState.levelIndex].dataSource[modalState.stepIndex].users = allUsers;
    }
    setFormFlowLevels(modifiedData);
  };

  const handleAddSectionsClick = () => {
    const modifiedData = _.cloneDeep(formFlowLevels);
    let sectionToAdd = updatedTemplate.template.filter((section: any) => allSelectedSections.includes(section._id));
    sectionToAdd = sectionToAdd.map((sec: any) => ({
      _id: sec._id,
      sectionCode: sec.sectionCode,
      sectionHeading: sec.sectionHeading,
    }));
    modifiedData[modalState.levelIndex].dataSource[modalState.stepIndex].sections = [
      ...modifiedData[modalState.levelIndex].dataSource[modalState.stepIndex].sections,
      ...sectionToAdd,
    ];
    setFormFlowLevels(modifiedData);
    setAllSelectedSections([]);
    closeAddModal();
  };
  const fetchFormFlowData = useCallback(async () => {
    const res = (await formFlowController({ formFlowId })) as any;
    if (res.data.status) {
      const formFlow = res.data.result.formFlow.map((level: any) => ({
        ...level,
        rejectBtnEditMode: false,
        approveBtnEditMode: false,
        rollBackBtnEditMode: false,
        headingEditMode: false,
        subBtnEditMode: false,
      }));
      setFormFlowData(res.data.result);
      setFormFlowLevels(formFlow);
    }
  }, [formFlowId]);

  const getUpdatedTemplate = async () => {
    const data = await formController({
      formId: formFlowData.selectedForm?._id,
      isArchived: false,
    });
    if (data.data.status) {
      setUpdatedTemplate({ ...data.data.result });
    }
  };

  useEffect(() => {
    if (!updatedTemplate._id && formFlowData.selectedForm) {
      getUpdatedTemplate();
    }
  }, [formFlowData.selectedForm?._id]);

  const setInitialData = () => {
    const usersData = spaceUsers.map((user) => ({
      id: user.id,
      name: `${user.fullName}`,
    }));
    const level_0_DataSource = [
      {
        type: "Fill",
        sections: [
          ...updatedTemplate.template.map((section: any) => ({
            _id: section._id,
            sectionCode: section.sectionCode,
            sectionHeading: section.sectionHeading,
          })),
        ],
        users: [...usersData],
      },
    ];
    const postSubDataSource = [
      {
        type: "Verify",
        sections: [
          ...updatedTemplate.template.map((section: any) => ({
            _id: section._id,
            sectionCode: section.sectionCode,
            sectionHeading: section.sectionHeading,
          })),
        ],
        users: [...usersData],
      },
    ];

    const gridData: any = [...initialValue];
    gridData[0].dataSource = level_0_DataSource;
    gridData[0].allowedUsersToSubmit = [...usersData];
    gridData[0].allowedUsersToReject = [...usersData];

    gridData[initialValue.length - 1].dataSource = postSubDataSource;
    gridData[initialValue.length - 1].allowedUsersToReject = [...usersData];
    gridData[initialValue.length - 1].allowedUsersToApprove = [...usersData];
    gridData[initialValue.length - 1].allowedUsersToRollBack = [...usersData];

    setFormFlowLevels(gridData);
  };
  useEffect(() => {
    if (formFlowId) {
      fetchFormFlowData();
    }
  }, [formFlowId, fetchFormFlowData]);

  useEffect(() => {
    // In single-level edit mode `formFlowLevels` is seeded from the `formFlow` prop, so skip
    // generating a fresh default flow (which would overwrite the level being edited).
    if (!formFlowId && updatedTemplate._id && !singleLevelEditMode) {
      setInitialData();
    }
  }, [updatedTemplate._id]);

  const getBtnDisableStatus = () => {
    let isActive = true;
    const fillSections = new Set(allSectionsUsedForFill);
    const verifySections = new Set(allSectionsUsedForVerify);
    if (
      fillSections.size < updatedTemplate?.template?.length ||
      verifySections.size < updatedTemplate?.template?.length
    ) {
      isActive = false;
    }
    formFlowLevels.map((eachLevel: any) => {
      if (eachLevel.dataSource.length) {
        eachLevel.dataSource.map((step: any) => {
          if (step.users.length == 0) {
            isActive = false;
          }
        });
      }
      if (eachLevel.allowedUsersToApprove && eachLevel.allowedUsersToApprove.length == 0) {
        isActive = false;
      }
      if (eachLevel.allowedUsersToReject && eachLevel.allowedUsersToReject.length == 0) {
        isActive = false;
      }
      if (eachLevel.allowedUsersToRollBack && eachLevel.allowedUsersToRollBack.length == 0) {
        isActive = false;
      }
      if (eachLevel.allowedUsersToSubmit && eachLevel.allowedUsersToSubmit.length == 0) {
        isActive = false;
      }
    });
    setSaveBtnState(isActive);
    return isActive;
  };

  useEffect(() => {
    getBtnDisableStatus();
  }, [allSectionsUsedForFill, allSectionsUsedForVerify, updatedTemplate]);

  const getSectionIds = (data: any) => {
    return data.sections.map((section: any) => section._id);
  };
  useEffect(() => {
    let allVerifySectionsUsed: any = [];
    let allFillSectionsUsed: any = [];

    formFlowLevels.map((level: any) => {
      level.dataSource.map((data: any) => {
        const allSectionIds = getSectionIds(data);
        if (data.type == "Verify") {
          allVerifySectionsUsed = [...allVerifySectionsUsed, ...allSectionIds];
        }
        if (data.type == "Fill") {
          allFillSectionsUsed = [...allFillSectionsUsed, ...allSectionIds];
        }
      });
    });
    setAllSectionsUsedForFill(() => [...allFillSectionsUsed]);
    setAllSectionsUsedForVerify(() => [...allVerifySectionsUsed]);
  }, [formFlowLevels]);

  const saveNewBtnName = ({ args, actionStep, levelIndex }: any) => {
    const modifiedData = _.cloneDeep(formFlowLevels);
    modifiedData[levelIndex][actionStep.btnTxtEditMode] = false;
    modifiedData[levelIndex][actionStep.btnTxtField] = args?.value ?? "";
    setFormFlowLevels(modifiedData);
  };
  const cancelBtnNameChange = ({ actionStep, levelIndex }: any) => {
    const modifiedData = _.cloneDeep(formFlowLevels);
    modifiedData[levelIndex][actionStep.btnTxtEditMode] = false;
    setFormFlowLevels(modifiedData);
  };

  const handleOptionSelect = ({ args, action, levelIndex, stepIndex, actionStep }: any) => {
    if (!action) {
      action = args.item.id;
    }
    let modifiedData = _.cloneDeep(formFlowLevels);

    switch (action) {
      case "deleteLevel": {
        modifiedData = modifiedData.filter((_: any, index: number) => index != levelIndex);
        setFormFlowLevels(modifiedData);
        break;
      }
      case "deleteStep": {
        modifiedData[levelIndex].dataSource = modifiedData[levelIndex].dataSource.filter(
          (_: any, index: number) => index != stepIndex,
        );
        setFormFlowLevels(modifiedData);
        break;
      }
      case "deleteAction": {
        delete modifiedData[levelIndex][actionStep.usersField];
        delete modifiedData[levelIndex][actionStep.btnTxtEditMode];
        delete modifiedData[levelIndex][actionStep.btnTxtField];
        setFormFlowLevels(modifiedData);
        break;
      }
      case "addLevelAfter": {
        handleAddLevelClick(levelIndex + 1);
        break;
      }
      case "addLevelBefore": {
        handleAddLevelClick(levelIndex);
        break;
      }
      case "renameLevel": {
        modifiedData[levelIndex] = {
          ...modifiedData[levelIndex],
          headingEditMode: true,
        };
        setFormFlowLevels(modifiedData);
        break;
      }
      case "duplicateLevel": {
        const levelToAdd = _.cloneDeep(modifiedData[levelIndex]);
        levelToAdd.dataSource = levelToAdd.dataSource.map((step: any) => {
          step.sections = [];
          return step;
        });
        const allNewLevels = [
          ...modifiedData.slice(0, levelIndex + 1),
          levelToAdd,
          ...modifiedData.slice(levelIndex + 1),
        ];
        setFormFlowLevels(() => [...allNewLevels]);
        break;
      }
      case "fill": {
        modifiedData[levelIndex] = {
          ...modifiedData[levelIndex],
          dataSource: [
            ...modifiedData[levelIndex].dataSource,
            {
              type: "Fill",
              sections: [],
              users: [],
            },
          ],
        };
        setFormFlowLevels(modifiedData);
        break;
      }
      case "modify": {
        modifiedData[levelIndex] = {
          ...modifiedData[levelIndex],
          dataSource: [
            ...modifiedData[levelIndex].dataSource,
            {
              type: "Modify",
              sections: [],
              users: [],
            },
          ],
        };
        setFormFlowLevels(modifiedData);
        break;
      }
      case "verify": {
        modifiedData[levelIndex] = {
          ...modifiedData[levelIndex],
          dataSource: [
            ...modifiedData[levelIndex].dataSource,
            {
              type: "Verify",
              sections: [],
              users: [],
            },
          ],
        };
        setFormFlowLevels(modifiedData);
        break;
      }
      case "moveBackward": {
        modifiedData[levelIndex] = {
          ...modifiedData[levelIndex],
          rollBackBtnTxt: "Revert Back",
          rollBackBtnEditMode: false,
          allowedUsersToRollBack: [],
        };
        setFormFlowLevels(modifiedData);
        break;
      }
      case "rejectForm": {
        modifiedData[levelIndex] = {
          ...modifiedData[levelIndex],
          rejectBtnTxt: "Reject",
          rejectBtnEditMode: false,
          allowedUsersToReject: [],
        };
        setFormFlowLevels(modifiedData);
        break;
      }
      case "removeSection": {
        modifiedData[levelIndex].dataSource[stepIndex].sections = modifiedData[levelIndex].dataSource[
          stepIndex
        ].sections.filter((section: any) => section._id != args.sectionId);
        setFormFlowLevels(modifiedData);
        break;
      }
      case "removeUser": {
        if (actionStep) {
          modifiedData[levelIndex][actionStep.usersField] = modifiedData[levelIndex][actionStep.usersField].filter(
            (user: any) => user.id != args.userId,
          );
        } else {
          modifiedData[levelIndex].dataSource[stepIndex].users = modifiedData[levelIndex].dataSource[
            stepIndex
          ].users.filter((user: any) => user.id != args.userId);
        }
        setFormFlowLevels(modifiedData);
        break;
      }
    }
  };
  const actionBtnEdit = ({ level, actionStep, levelIndex }: any) => {
    return (
      <InPlaceEditorComponent
        mode="Inline"
        id={`${levelIndex}-${actionStep.btnTxtField}`}
        value={level[actionStep.btnTxtField]}
        enableEditMode
        actionSuccess={(args) => saveNewBtnName({ args, actionStep, levelIndex })}
        cancelClick={() => cancelBtnNameChange({ actionStep, levelIndex })}
        model={{ placeholder: "Type Here" }}
        type="Text"
        validationRules={{ Text: { required: true, maxLength: 50 } }}
        name="Text"
      />
    );
  };

  const handleActionBtnEdit = ({ levelIndex, actionStep }: any) => {
    const modifiedData = _.cloneDeep(formFlowLevels);
    modifiedData[levelIndex][actionStep.btnTxtEditMode] = true;
    setFormFlowLevels(modifiedData);
  };

  const header = () => {
    return (
      <div className="flex items-center gap-2 border-button_light border-b h-20 w-full">
        <div>
          <IconComponent
            name="ArrowLeft"
            width="1.5rem"
            height="1.5rem"
            className="cursor-pointer"
            onClick={handleBackClick}
          />
        </div>
        <div className="flex flex-col gap-1">
          <div className="font-semibold text-xl">{formFlowData.name}</div>
          <div className="text-sm">{updatedTemplate?.name}</div>
        </div>
      </div>
    );
  };
  const handleEditHeaderCancelClick = (levelIndex: any) => {
    const data = _.cloneDeep(formFlowLevels);
    data[levelIndex] = { ...data[levelIndex], headingEditMode: false };
    setFormFlowLevels(() => data);
  };

  const saveNewHeaderName = ({ args, levelIndex }: any) => {
    const data = _.cloneDeep(formFlowLevels);
    data[levelIndex] = {
      ...data[levelIndex],
      heading: String(args?.value ?? "").substring(0, 100),
      headingEditMode: false,
    };
    setFormFlowLevels(() => data);
  };
  const levelHeader = ({ level, levelIndex }: any) => {
    const showDefaultChip = levelIndex == 0 || levelIndex == formFlowLevels.length - 1;
    return (
      <div className="justify-between w-full p-3 border-b border-stroke_primary_light flex items-center">
        <div className="font-semibold flex items-center">
          {level.headingEditMode ? (
            <Box onClick={(e: React.SyntheticEvent) => e.stopPropagation()}>
              <InPlaceEditorComponent
                mode="Inline"
                enableEditMode
                value={level.heading}
                actionSuccess={(args) => saveNewHeaderName({ args, levelIndex })}
                cancelClick={() => handleEditHeaderCancelClick(levelIndex)}
                model={{ placeholder: "Type Here" }}
                type="Text"
                validationRules={{ Text: { required: true, maxLength: 100 } }}
                name="Text"
              />
            </Box>
          ) : (
            <div className="flex items-center gap-4">
              {level.heading}
              {showDefaultChip && (
                <Chip
                  size="small"
                  sx={{
                    fontWeight: 400,
                    background: "#666a84",
                    color: "white",
                  }}
                  label="Default"
                />
              )}
            </div>
          )}
        </div>
        <div className="flex gap-3 items-center">
          <IconComponent name="arrowDown" width="1rem" height="1rem" />
          {editMode && (
            <Box onClick={(e) => e.stopPropagation()}>
              <SelectDropDown
                select={(args) => handleOptionSelect({ args, levelIndex })}
                cssClass="e-caret-hide"
                bgColor="transparent"
                items={[
                  ...(levelIndex != formFlowLevels.length - 1
                    ? [
                        {
                          text: t("Add level after"),
                          id: "addLevelAfter",
                        },
                      ]
                    : []),
                  ...(levelIndex != 0
                    ? [
                        {
                          text: t("Add level before"),
                          id: "addLevelBefore",
                        },
                      ]
                    : []),
                  {
                    text: t("Rename"),
                    id: "renameLevel",
                  },
                  ...(levelIndex != formFlowLevels.length - 1 && levelIndex != 0
                    ? [
                        {
                          text: "Delete",
                          id: "deleteLevel",
                        },
                      ]
                    : []),
                  ...(levelIndex != formFlowLevels.length - 1
                    ? [
                        {
                          text: "Duplicate",
                          id: "duplicateLevel",
                        },
                      ]
                    : []),
                ]}
              >
                <IconComponent name="threedots" width="1.25rem" height="1.25rem" className="cursor-pointer" />
              </SelectDropDown>
            </Box>
          )}
        </div>
      </div>
    );
  };
  const stepHeader = ({ stepData, stepIndex, levelIndex }: any) => {
    return (
      <div className="justify-between w-full p-2 border-b border-stroke_primary_light flex items-center">
        <div className="flex items-center font-semibold">{stepData.type}</div>
        {editMode && (
          <Box onClick={(e) => e.stopPropagation()}>
            <SelectDropDown
              select={(args) => handleOptionSelect({ args, levelIndex, stepIndex })}
              cssClass="e-caret-hide"
              bgColor="transparent"
              items={[
                {
                  text: "Delete",
                  id: "deleteStep",
                },
              ]}
            >
              <IconComponent name="threedots" width="1.25rem" height="1.25rem" className="cursor-pointer" />
            </SelectDropDown>
          </Box>
        )}
      </div>
    );
  };
  const stepContent = ({ stepData, stepIndex, levelIndex }: any) => {
    let currentSections: any = [];
    if (stepData.type == "Fill") {
      currentSections = [...allSectionsUsedForFill];
    } else if (stepData.type == "Verify") {
      currentSections = [...allSectionsUsedForVerify];
    } else if (stepData.type == "Modify") {
      const sections = stepData.sections.map((sec: any) => sec._id);
      currentSections = [...sections];
    }
    return (
      <div className="flex gap-4 flex-col w-full">
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-4">
            <Text>{t("Sections")}</Text>
            {editMode && (
              <div>
                <ButtonComponent
                  sx={{ padding: "0.375rem" }}
                  onClick={() => {
                    setModalState({
                      modalName: "sections",
                      levelIndex,
                      stepIndex,
                      currentUsers: [],
                      currentSections,
                      stepData,
                    });
                  }}
                >
                  <IconComponent name="add" width="1.25rem" height="1.25rem" />
                </ButtonComponent>
              </div>
            )}
          </div>
          <div className="flex gap-2 flex-wrap">
            {stepData.sections.map((section: any) => (
              <div
                key={section._id}
                className="border items-center rounded flex gap-2 border-stroke_primary_light px-2 py-1"
              >
                {getSectionName(section)}
                {editMode && (
                  <IconComponent
                    onClick={() => {
                      handleOptionSelect({
                        args: { sectionId: section._id },
                        levelIndex,
                        stepIndex,
                        action: "removeSection",
                      });
                    }}
                    className="cursor-pointer"
                    name="cross"
                    width="1rem"
                    height="1rem"
                  />
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="border-t border-stroke_primary_light" />
        <div className="flex flex-col gap-4">
          <div className="flex gap-4 items-center">
            <Text>{t("Users")}</Text>
            {editMode && (
              <div>
                <ButtonComponent
                  sx={{ padding: "0.375rem" }}
                  onClick={() =>
                    setModalState({
                      modalName: "users",
                      levelIndex,
                      stepIndex,
                      currentUsers: stepData.users,
                      currentSections: [],
                    })
                  }
                >
                  <IconComponent name="UserProfile" width="1.25rem" height="1.25rem" />
                </ButtonComponent>
              </div>
            )}
          </div>
          <div className="flex gap-2 flex-wrap">
            {stepData.users.map((user: any) =>
              editMode ? (
                <UserNameTagComponent
                  key={user.id}
                  handleDeleteIconClicked={() => {
                    handleOptionSelect({
                      args: { userId: user.id },
                      action: "removeUser",
                      levelIndex,
                      stepIndex,
                    });
                  }}
                  id={user.id}
                />
              ) : (
                <UserNameTagComponent key={user.id} id={user.id} />
              ),
            )}
          </div>
        </div>
      </div>
    );
  };

  const actionHeader = ({ actionStep, levelIndex }: any) => {
    return (
      <div className="justify-between w-full p-2 border-b border-stroke_primary_light flex items-center">
        <div className="flex items-center font-semibold">{actionStep.name}</div>
        {editMode && !["moveForward", "approveForm"].includes(actionStep.id) && (
          <Box onClick={(e) => e.stopPropagation()}>
            <SelectDropDown
              select={(args) =>
                handleOptionSelect({
                  args,
                  levelIndex,
                  actionStep,
                })
              }
              cssClass="e-caret-hide"
              bgColor="transparent"
              items={[
                {
                  text: "Delete",
                  id: "deleteAction",
                },
              ]}
            >
              <IconComponent name="threedots" width="1.25rem" height="1.25rem" className="cursor-pointer" />
            </SelectDropDown>
          </Box>
        )}
      </div>
    );
  };
  const actionContent = ({ actionStep, levelIndex, level }: { actionStep: any; levelIndex: any; level: any }) => {
    return (
      <div className="flex gap-4 flex-col w-full">
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-4">
            <Text>{t("Display Button")}</Text>
            {editMode && (
              <div>
                <ButtonComponent
                  sx={{ padding: "0.375rem" }}
                  onClick={() => handleActionBtnEdit({ levelIndex, actionStep })}
                >
                  <IconComponent name="editProfile" width="1.25rem" height="1.25rem" />
                </ButtonComponent>
              </div>
            )}
          </div>
          <div className="flex gap-2 flex-wrap">
            {level[actionStep.btnTxtEditMode] ? (
              actionBtnEdit({ level, actionStep, levelIndex })
            ) : (
              <ButtonComponent>{level[actionStep.btnTxtField]}</ButtonComponent>
            )}
          </div>
        </div>
        <div className="border-t border-stroke_primary_light" />
        <div className="flex flex-col gap-4">
          <div className="flex gap-4 items-center">
            <Text>{t("Users")}</Text>
            {editMode && (
              <div>
                <ButtonComponent
                  sx={{ padding: "0.375rem" }}
                  onClick={() =>
                    setModalState({
                      modalName: "users",
                      levelIndex,
                      actionStep,
                      currentUsers: level[actionStep.usersField],
                      currentSections: [],
                    })
                  }
                >
                  <IconComponent name="UserProfile" width="1.25rem" height="1.25rem" />
                </ButtonComponent>
              </div>
            )}
          </div>
          <div className="flex gap-2 flex-wrap">
            {level[actionStep.usersField]?.map((user: any) => (
              <UserNameTagComponent
                key={user.id}
                handleDeleteIconClicked={
                  editMode
                    ? () => {
                        handleOptionSelect({
                          args: { userId: user.id },
                          action: "removeUser",
                          levelIndex,
                          actionStep,
                        });
                      }
                    : undefined
                }
                id={user.id}
              />
            ))}
          </div>
        </div>
      </div>
    );
  };
  const getSteps = ({ dataSource, levelIndex }: any) => {
    return (
      <div key={levelIndex} className="flex flex-col gap-4 items-center">
        {dataSource.map((stepData: any, stepIndex: number) => (
          <Accordion
            defaultExpanded
            border="1px solid var(--stroke-primary)"
            style={{ width: "100%" }}
            borderRadius="0.625rem"
            key={`${stepData.type}-${stepIndex}`}
          >
            <AccordionSummary
            // expandIcon={<ExpandMoreIcon className="pe-2 m-5 " />}
            >
              {stepHeader({ stepData, stepIndex, levelIndex })}
            </AccordionSummary>
            <AccordionDetails>{stepContent({ stepData, stepIndex, levelIndex })}</AccordionDetails>
          </Accordion>
        ))}
      </div>
    );
  };

  const getStep_ActionOptions = ({ items, levelIndex, source, level }: any) => {
    return (
      <SelectDropDown
        select={(args) => handleOptionSelect({ args, levelIndex })}
        cssClass="e-caret-hide"
        bgColor="transparent"
        items={items}
        beforeOpen={(args) => {
          if (source == "actions") {
            if (args.items?.[0])
              args.items[0].disabled = levelIndex == 0 || Object.hasOwn(level, "allowedUsersToRollBack");
            if (args.items?.[1]) args.items[1].disabled = Object.hasOwn(level, "allowedUsersToReject");
          }
        }}
      >
        <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}>
          <span className="flex items-center gap-1">
            <IconComponent name="add" width="1rem" height="1rem" />
            <Text>{t("Add")}</Text>
            <IconComponent name="arrowDownSm" width="1rem" height="1rem" />
          </span>
        </ButtonComponent>
      </SelectDropDown>
    );
  };
  const handleConditionChange = ({ levelIndex, field, value }: any) => {
    const modifiedData = _.cloneDeep(formFlowLevels);
    modifiedData[levelIndex][field] = value;
    setFormFlowLevels(modifiedData);
  };
  const getActions = ({ level, levelIndex }: any) => {
    const filteredSteps = actionSteps.filter((step: any) => !!Object.hasOwn(level, step.btnTxtField));
    return (
      <div key={levelIndex} className="flex flex-col gap-4 w-full">
        {filteredSteps.map((actionStep: any) => (
          <Accordion
            defaultExpanded
            key={actionStep.id}
            border="1px solid var(--stroke-primary)"
            style={{ width: "100%" }}
            borderRadius="0.625rem"
          >
            <AccordionSummary>{actionHeader({ actionStep, level, levelIndex })}</AccordionSummary>
            <AccordionDetails>{actionContent({ actionStep, level, levelIndex })}</AccordionDetails>
          </Accordion>
        ))}
        {levelIndex != 0 && (
          <div className="flex flex-col gap-3 w-full border-t border-stroke_primary_light pt-4">
            <Text className="font-semibold">{t("Conditions")}</Text>
            <div className="flex items-center gap-2 w-full border border-stroke_primary_light rounded-lg p-3">
              <CheckBoxComponent
                enabled={editMode}
                checked={!!level.allowDynamicUserConfig}
                onChange={(_args: any, checked: boolean) =>
                  handleConditionChange({ levelIndex, field: "allowDynamicUserConfig", value: checked })
                }
              />
              <Text noWrap>{t("Allow dynamic user configuration at previous level submission")}</Text>
            </div>
          </div>
        )}
      </div>
    );
  };
  const levelContent = ({ level, levelIndex }: any) => {
    return (
      <div className="flex">
        <div className="flex-1 flex flex-col gap-3 p-3">
          <div className="flex items-center gap-3">
            <Text className="font-semibold">{t("Steps")}</Text>
            {editMode &&
              getStep_ActionOptions({
                levelIndex,
                level,
                source: "steps",
                items: [
                  {
                    text: t("Fill"),
                    id: "fill",
                  },
                  {
                    text: t("Modify"),
                    id: "modify",
                  },
                  ...(levelIndex == formFlowLevels.length - 1
                    ? [
                        {
                          text: t("Verify"),
                          id: "verify",
                        },
                      ]
                    : []),
                ],
              })}
          </div>
          <div>{getSteps({ dataSource: level.dataSource, levelIndex })}</div>
        </div>
        <div className="border-s border-stroke_primary_light" />
        <div className="flex-1 flex flex-col gap-3 p-3">
          <div className="flex items-center gap-3">
            <Text className="font-semibold">{t("Actions")}</Text>
            {editMode &&
              getStep_ActionOptions({
                levelIndex,
                level,
                source: "actions",
                items: [
                  {
                    text: t("Move Backward"),
                    id: "moveBackward",
                  },
                  {
                    text: t("Reject Form"),
                    id: "rejectForm",
                  },
                ],
              })}
          </div>
          <div>{getActions({ level, levelIndex })}</div>
        </div>
      </div>
    );
  };
  const formFlowContent = () => {
    return (
      <div className="overflow-auto w-full flex flex-col gap-4">
        {formFlowLevels.map((level: any, levelIndex: number) => (
          <Accordion
            key={level.heading}
            style={{ width: "100%" }}
            defaultExpanded
            border="1px solid var(--stroke-primary)"
            borderRadius="0.625rem"
            // sx={{ flexShrink: 0 }}
          >
            <AccordionSummary
            // expandIcon={<ExpandMoreIcon/>}
            >
              {levelHeader({ level, levelIndex })}
            </AccordionSummary>
            <AccordionDetails sx={{ padding: "0 !important" }}>{levelContent({ level, levelIndex })}</AccordionDetails>
          </Accordion>
        ))}
      </div>
    );
  };

  const handleSave = async () => {
    const updatedFormFlow = formFlowLevels.map((level: any) => {
      delete level.subBtnEditMode;
      delete level.rejectBtnEditMode;
      delete level.rollBackBtnEditMode;
      delete level.approveBtnEditMode;
      delete level.headingEditMode;

      return level;
    });
    const data = {
      _id: formFlowId,
      data: {
        formFlow: updatedFormFlow,
        projectId,
        "selectedForm.template": updatedTemplate.template,
        "selectedForm.name": updatedTemplate.name,
        "selectedForm.description": updatedTemplate.description,
      },
      action: "update" as const,
    };
    const res = (await formFlowController(data)) as any;
    if (res.data.status) {
      handleBackClick();
      dispatch(
        showToastNotification({
          content: t('Form flow "{{name}}" saved successfully', { name: formFlowData.name }),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
    } else {
      dispatch(
        showToastNotification({
          content: untranslated(res.data.errorMessage) ?? SOMETHING_WENT_WRONG,
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };
  const handleCancelEditClick = async () => {
    if (formFlowId) {
      await fetchFormFlowData();
    } else {
      setInitialData();
    }
    setEditMode(false);
  };
  const handleAddLevelClick = (destinationIndex = formFlowLevels.length - 1) => {
    const currentLevels = _.cloneDeep(formFlowLevels);
    const newLevel = {
      heading: `Intermediate level-${Math.max(formFlowLevels.length, 1)}`,
      headingEditMode: false,
      dataSource: [],
      allowedUsersToSubmit: [],
      allowedUsersToReject: [],
      submitBtnTxt: "Submit",
      rejectBtnTxt: "Reject",
      subBtnEditMode: false,
      rejectBtnEditMode: false,
      rollBackBtnEditMode: false,
    };
    const allNewLevels = [
      ...currentLevels.slice(0, destinationIndex),
      newLevel,
      ...currentLevels.slice(destinationIndex),
    ];
    setFormFlowLevels(() => [...allNewLevels]);
  };
  const headerBtns = () =>
    editMode ? (
      <div className="flex gap-4">
        {source != "FORM_CREATION" && (
          <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON} disabled={!saveBtnState} onClick={handleSave}>
            <Text>{t("Save")}</Text>
          </ButtonComponent>
        )}
        <ButtonComponent onClick={() => handleAddLevelClick()} buttonType="backgroundButton" disabled={!editMode}>
          <span className="flex items-center gap-1">
            <PlusIcon color={!editMode ? "var(--system-colour-37)" : "var(--primary-text)"} />
            <Text>{t("Add Level")}</Text>
          </span>
        </ButtonComponent>

        <ButtonComponent disabled={!editMode} onClick={handleCancelEditClick}>
          <Text>{t("Cancel")}</Text>
        </ButtonComponent>
      </div>
    ) : (
      <div>
        <ButtonComponent disabled={editMode} onClick={() => setEditMode(true)}>
          <div className="flex items-center gap-1">
            <IconComponent
              className={editMode ? "opacity-40" : ""}
              name="editProfile"
              width="1.25rem"
              height="1.25rem"
            />
            <Text>{t("Edit")}</Text>
          </div>
        </ButtonComponent>
      </div>
    );

  const addSectionHeader = () => {
    return (
      <div className="  w-full flex justify-between rounded-md">
        <Text>{t("Add Sections")}</Text>
      </div>
    );
  };
  const handleSectionSelection = ({ isChecked, sectionId }: any) => {
    if (isChecked) {
      setAllSelectedSections((prev: any) => [...prev, sectionId]);
    } else {
      setAllSelectedSections((prev: any) => prev.filter((secId: any) => secId != sectionId));
    }
  };

  const addSectionContent = () => {
    const template = updatedTemplate?.template ?? [];
    let filteredTemplate = template.filter((sec: any) => !modalState.currentSections.includes(sec._id));
    if (modalState?.stepData?.type == "Modify") {
      filteredTemplate = template
        .filter((sec: any) => allSectionsUsedForFill.includes(sec._id))
        .filter((secId: any) => !modalState.currentSections.includes(secId));
    }
    return (
      <div className="w-full overflow-auto">
        {filteredTemplate.length ? (
          <FormPreview
            fullWidthInput
            showHeaderCheckBox
            allowBorder
            disabled
            defaultExpanded={false}
            handleSectionSelection={handleSectionSelection}
            selectedSections={allSelectedSections}
            formData={{ template: filteredTemplate }}
          />
        ) : (
          <div className="flex flex-col gap-3 items-center justify-center w-full h-full">
            <IconComponent name="InspectionFormNoData" width="18.75rem" height="18.75rem" />
            <Text>{t("No section available to add")}</Text>
          </div>
        )}
      </div>
    );
  };
  const addSectionFooter = () => (
    <div className="flex gap-4 items-center">
      <ButtonComponent disabled={allSelectedSections.length == 0} onClick={handleAddSectionsClick}>
        <Text>{t("Add")}</Text>
      </ButtonComponent>
      <ButtonComponent onClick={closeAddModal}>
        <Text>{t("Cancel")}</Text>
      </ButtonComponent>
    </div>
  );
  const handleCloseModalClick = () => {
    setOpenNewFlowSaveModal({ status: false, title: "" });
  };

  const handleSaveFlowClick = async () => {
    if (!resolvedSpaceId) {
      dispatch(showToastNotification({ content: t("Please select a space"), type: TOAST_TYPE_ERROR }));
      return;
    }
    const updatedFormFlow = formFlowLevels.map((level: any) => {
      delete level.subBtnEditMode;
      delete level.headingEditMode;
      delete level.rejectBtnEditMode;
      delete level.rollBackBtnEditMode;
      delete level.approveBtnEditMode;

      return level;
    });
    const data = {
      data: {
        name: openNewFlowSaveModal.title,
        selectedForm: {
          template: updatedTemplate.template,
          _id: updatedTemplate._id,
          name: updatedTemplate.name,
          description: updatedTemplate.description,
        },
        formCategory: updatedTemplate.resourceType,
        formFlow: updatedFormFlow,
        projectId,
        spaceId: resolvedSpaceId,
      },
      action: "save" as const,
    };
    const res = (await formFlowController(data)) as any;
    if (res.data.status) {
      dispatch(
        showToastNotification({
          content: t('New Form Flow "{{name}}" has been created successfully', { name: data.data.name }),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
      handleCloseModalClick();
    } else {
      dispatch(
        showToastNotification({
          content: res.data.errorMessage,
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };
  const handleFlowNameChange = (args: any) => {
    setOpenNewFlowSaveModal((prev) => ({
      ...prev,
      title: args.target.value,
    }));
  };

  const addFlowHeader = () => (
    <div className="  w-full flex justify-between rounded-md">
      <div className="flex gap-3 items-center justify-center">
        <div className="flex flex-col gap-1">
          <Text>{t("Save Form Flow")}</Text>
        </div>
      </div>
    </div>
  );
  const addFlowContent = () => (
    <div className=" flex flex-col gap-1">
      <div className="flex flex-col gap-4">
        <Text>{t("Form Flow Name")}</Text>
        <span>
          <TextFieldComponent
            name="name"
            type="text"
            placeholder={t("Add form flow name")}
            showClearButton
            onChange={handleFlowNameChange}
            value={openNewFlowSaveModal.title}
          />
        </span>
      </div>
    </div>
  );
  const showAddFlowHeader = () => {
    return (
      <div className="flex pb-5 gap-4 items-center">
        <span className="flex gap-3 items-center">
          <Text className="whitespace-normal">
            {t(
              "You are creating a new form flow which will only apply for the current case. You can also save this for re-use if you’d like.",
            )}
          </Text>
          <span>
            <ButtonComponent
              disabled={!saveBtnState}
              onClick={() => setOpenNewFlowSaveModal({ status: true, title: "" })}
              buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
            >
              <Text>{t("Save Form Flow")}</Text>
            </ButtonComponent>
          </span>
        </span>
      </div>
    );
  };

  const getFooterBtns = () => {
    return (
      <div className="mt-6 me-6 mb-6 ms-0 flex gap-4">
        <ButtonComponent
          disabled={!saveBtnState}
          buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
          loading={showLoader}
          onClick={() => handleCreateClick(formFlowLevels)}
        >
          <Text>{t("Create")}</Text>
        </ButtonComponent>
        <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON} onClick={handleCancelFormAttachment}>
          <Text>{t("Cancel")}</Text>
        </ButtonComponent>
      </div>
    );
  };
  const showSaveDisclaimer = () => (
    <div className="p-2 rounded-sm bg-banner_color_yellow/40 font-normal text-sm text-black content-center">
      <Text>
        {t(
          "Please ensure that all sections have fill permissions assigned and each action includes at least one user to proceed with saving.",
        )}
      </Text>
    </div>
  );

  // Add-users / add-sections popups are shared between the full editor and the single-level modal.
  const renderSharedModals = () => (
    <>
      {modalState.modalName == "users" && (
        <AddUser
          customQuery={addUserQuery}
          selectionType="multipleUser"
          currentUsers={modalState.currentUsers}
          closeUsersModal={closeAddModal}
          handleAddUserClick={handleAddUsersClick}
        />
      )}
      {modalState.modalName == "sections" && (
        <ModalStateDialogComponent
          allowModalPadding={false}
          footerContent={addSectionFooter()}
          width="70%"
          height="100%"
          headerTitle={addSectionHeader()}
          onCancel={closeAddModal}
          isVisible
          modelContent={addSectionContent()}
        />
      )}
    </>
  );

  // ----- Single-level edit mode -----
  // Removes the UI-only edit flags before handing a level back to the parent.
  const stripLevelEditFlags = (level: any) => {
    const cleaned = _.cloneDeep(level);
    delete cleaned.headingEditMode;
    delete cleaned.subBtnEditMode;
    delete cleaned.rejectBtnEditMode;
    delete cleaned.rollBackBtnEditMode;
    delete cleaned.approveBtnEditMode;
    return cleaned;
  };

  useEffect(() => {
    if (!singleLevelEditMode || editLevelIndex == null) return;
    const level = formFlowLevels[editLevelIndex];
    if (!level) return;
    onLevelChange(stripLevelEditFlags(level), saveBtnState);
  }, [formFlowLevels, editLevelIndex, singleLevelEditMode, saveBtnState]);

  if (singleLevelEditMode) {
    const level = editLevelIndex != null ? formFlowLevels[editLevelIndex] : null;
    return (
      <div className="w-full">
        {level && (
          <div className="p-4 flex flex-col gap-4">
            {!saveBtnState && showSaveDisclaimer()}
            {levelContent({ level, levelIndex: editLevelIndex })}
          </div>
        )}
        {renderSharedModals()}
      </div>
    );
  }

  return (
    <div className="flex p-4 gap-4 h-full flex-col overflow-auto w-full">
      {!(source == "FORM_CREATION" || previewMode) && header()}
      {source == "FORM_CREATION" && showAddFlowHeader()}
      {!previewMode && headerBtns()}
      {!saveBtnState && showSaveDisclaimer()}
      {formFlowContent()}
      {source == "FORM_CREATION" && getFooterBtns()}
      {renderSharedModals()}
      {openNewFlowSaveModal.status && (
        <ModalStateDialogComponent
          allowModalPadding={false}
          footerContent={
            <div className="">
              <ButtonComponent
                disabled={openNewFlowSaveModal.title.trim() == ""}
                onClick={handleSaveFlowClick}
                buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
              >
                <Text>{t("Save")}</Text>
              </ButtonComponent>{" "}
            </div>
          }
          width="30%"
          headerTitle={addFlowHeader()}
          onCancel={handleCloseModalClick}
          isVisible={openNewFlowSaveModal.status}
          modelContent={addFlowContent()}
        />
      )}
    </div>
  );
}
export default FormFlowCreationNew;
